var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkshops(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9987 1.66602H14.9987C15.9154 1.66602 16.6654 2.41602 16.6654 3.33269V6.9327H3.33203V3.33269C3.33203 2.41602 4.08203 1.66602 4.9987 1.66602Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 6.93359V9.90025C3.33203 10.8003 3.81539 11.6336 4.60706 12.0753L7.07369 13.4669C7.59869 13.7586 7.92371 14.317 7.92371 14.917V16.6669C7.92371 17.5836 8.67371 18.3336 9.59037 18.3336H10.4237C11.3404 18.3336 12.0904 17.5836 12.0904 16.6669V14.917C12.0904 14.317 12.4154 13.7586 12.9404 13.4669L15.407 12.0753C16.1904 11.6336 16.682 10.8003 16.682 9.90025V6.93359H3.33203Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshops);
export default __webpack_public_path__ + "static/media/workshops.770a4b64683f5e3998220ae525dee622.svg";
export { ForwardRef as ReactComponent };